module.exports = __webpack_public_path__ + "img/se.8a861197.svg";